import { revokeAdConsentInBrowser } from "../../utils/ad-consent";

/**
 * Account > Personal information: switching the ads-consent toggle off withdraws the consent given via the
 * cookie banner. One-way: the switch is rendered disabled once off, consent is only granted through the
 * banner. The server flips the database flag and the consent cookies; here the pixels are revoked.
 */
export const initAccountAdsConsent = () => {
  const block = document.querySelector("[data-ads-consent-withdraw-url]") as HTMLElement | null;

  if (!block) {
    return;
  }

  const withdrawUrl = block.dataset.adsConsentWithdrawUrl as string;
  const toggle = block.querySelector("input.ads-consent-switch") as HTMLInputElement | null;

  if (!toggle || toggle.disabled) {
    return;
  }

  toggle.addEventListener("change", () => {
    if (toggle.checked) {
      return;
    }

    toggle.disabled = true;

    fetch(withdrawUrl, {
      credentials: "same-origin",
      method: "put",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Withdrawing ads consent failed: ${response.status}`);
        }

        revokeAdConsentInBrowser();
      })
      .catch((e) => {
        console.log(e);
        toggle.checked = true;
        toggle.disabled = false;
      });
  });
};
